/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Point } from './Point';
import {
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './Point';
import type { RangeDTO } from './RangeDTO';
import {
    RangeDTOFromJSON,
    RangeDTOFromJSONTyped,
    RangeDTOToJSON,
} from './RangeDTO';

/**
 * 
 * @export
 * @interface SingleCustomTimeSeriesView
 */
export interface SingleCustomTimeSeriesView {
    /**
     * 
     * @type {number}
     * @memberof SingleCustomTimeSeriesView
     */
    baseline?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleCustomTimeSeriesView
     */
    customId: string;
    /**
     * Paths of run attributes referenced in the custom X formula without a default that the run doesn't have as a finite float or int value. The series has no values in that case.
     * @type {Array<string>}
     * @memberof SingleCustomTimeSeriesView
     */
    missingRunAttributes?: Array<string>;
    /**
     * 
     * @type {Array<Point>}
     * @memberof SingleCustomTimeSeriesView
     */
    values: Array<Point>;
    /**
     * 
     * @type {RangeDTO}
     * @memberof SingleCustomTimeSeriesView
     */
    xrange?: RangeDTO;
    /**
     * 
     * @type {RangeDTO}
     * @memberof SingleCustomTimeSeriesView
     */
    yrange?: RangeDTO;
}

/**
 * Check if a given object implements the SingleCustomTimeSeriesView interface.
 */
export function instanceOfSingleCustomTimeSeriesView(value: object): value is SingleCustomTimeSeriesView {
    if (!('customId' in value) || value['customId'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function SingleCustomTimeSeriesViewFromJSON(json: any): SingleCustomTimeSeriesView {
    return SingleCustomTimeSeriesViewFromJSONTyped(json, false);
}

export function SingleCustomTimeSeriesViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleCustomTimeSeriesView {
    if (json == null) {
        return json;
    }
    return {
        
        'baseline': json['baseline'] == null ? undefined : json['baseline'],
        'customId': json['customId'],
        'missingRunAttributes': json['missingRunAttributes'] == null ? undefined : json['missingRunAttributes'],
        'values': ((json['values'] as Array<any>).map(PointFromJSON)),
        'xrange': json['xrange'] == null ? undefined : RangeDTOFromJSON(json['xrange']),
        'yrange': json['yrange'] == null ? undefined : RangeDTOFromJSON(json['yrange']),
    };
}

export function SingleCustomTimeSeriesViewToJSON(value?: SingleCustomTimeSeriesView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'baseline': value['baseline'],
        'customId': value['customId'],
        'missingRunAttributes': value['missingRunAttributes'],
        'values': ((value['values'] as Array<any>).map(PointToJSON)),
        'xrange': RangeDTOToJSON(value['xrange']),
        'yrange': RangeDTOToJSON(value['yrange']),
    };
}

